const API_URL = (import.meta.env.VITE_API_URL as string) ?? '';

let municipalityId: string | null = null;
const startTime = Date.now();

// Token for authenticating with the log endpoint
const TOTEM_LOG_TOKEN = import.meta.env.VITE_TOTEM_LOG_TOKEN || '';

export const setLoggerMunicipalityId = (id: string) => {
  municipalityId = id;
};

export const logToRemote = async (
  eventType: string,
  metadata?: Record<string, any>,
  logLevel: 'info' | 'warn' | 'error' | 'critical' = 'info'
) => {
  // Skip logging if no token configured (prevents errors in dev)
  if (!TOTEM_LOG_TOKEN) {
    console.log(`📊 [Local] ${eventType}`, metadata);
    return;
  }

  try {
    const payload = {
      municipality_id: municipalityId,
      log_level: logLevel,
      event_type: eventType,
      message: metadata?.message || eventType,
      metadata: {
        ...metadata,
        screen_resolution: `${window.screen.width}x${window.screen.height}`,
        uptime_seconds: Math.floor((Date.now() - startTime) / 1000),
        url: window.location.href,
        timestamp: new Date().toISOString()
      }
    };

    const res = await fetch(`${API_URL}/totem-logs`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-totem-token': TOTEM_LOG_TOKEN,
      },
      body: JSON.stringify(payload),
    });

    if (!res.ok) {
      console.error('Error al loggear:', await res.text());
    } else {
      console.log(`📊 Logged to remote: ${eventType}`, metadata);
    }
  } catch (error) {
    console.error('Failed to log to remote:', error);
  }
};
